import { lazy } from 'react';

const Layout = lazy(() => import('./Layout/Layout'));

export const OmniCloudLayouts = {
  layout: Layout,
};
